<template>
  <div
    :class="[
      style['bottom-panel'],
      { [style['panel-timer']]: currentPanelComponent === 'TimePicker' }
    ]"
  >
    <datepicker
      v-show="currentPanelComponent === 'Datepicker'"
      v-model="selectedDate"
      :disabled-dates="disabledDates"
      :enabled-dates="enabledDates"
      :language="computedDateLanguage"
    />
    <time-picker
      v-if="currentPanelComponent === 'TimePicker'"
      :selected-time="selectedTime"
      :selected-date="selectedDate"
      :time-limited="timeLimited"
      :update-selected-time="updateSelectedTime"
    />
    <div :class="style['panel-control']">
      <div :class="style.left">
        <button
          v-if="currentPanelComponent === 'TimePicker'"
          :class="style['bp-button']"
          type="button"
          @click="currentPanelComponent = 'Datepicker'"
        >
          {{ $t('back') }}
        </button>
      </div>
      <div :class="style.right">
        <button :class="style['bp-button']" type="button" @click="closePanel">
          {{ $t('close') }}
        </button>
        <button
          v-if="currentPanelComponent === 'Datepicker'"
          :class="style['bp-button']"
          type="button"
          @click="currentPanelComponent = 'TimePicker'"
        >
          {{ $t('next') }}
        </button>
        <button
          v-if="currentPanelComponent === 'TimePicker'"
          :class="style['bp-button']"
          type="button"
          @click="bottomPanelSend"
        >
          {{ $t('send') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from '../Components/Datepicker/components/Datepicker.vue'
import TimePicker from '../Components/TimePicker.vue'
import DateEN from '../Components/Datepicker/locale/translations/en'
import DateJA from '../Components/Datepicker/locale/translations/ja'
import DateZH from '../Components/Datepicker/locale/translations/zh'
import DateKO from '../Components/Datepicker/locale/translations/ko'
import { EventBus } from 'ChatWidget/EventBus'
import style from '../scss/_bottompanel.scss'
import { Chat } from 'src/apis'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useDatepickerStore } from 'Store/datepicker'
import { useFormStore } from 'Store/form'

export default {
  components: {
    Datepicker,
    TimePicker
  },

  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      datepickerStore: useDatepickerStore(),
      formStore: useFormStore()
    }
  },

  props: {
    disabledDates: Object,
    enabledDates: Object
  },
  data() {
    return {
      selectedDate: this.datepickerStore.settings.currentDate || '',
      selectedTime: this.datepickerStore.settings.currentTime || '',
      datePickerWidgetId: this.datepickerStore.settings.datePickerWidgetId,
      timeLimited: this.datepickerStore.settings.timeLimited,
      currentPanelComponent: 'Datepicker',
      datePickerIsOpen: true,
      isTimePickerOpen: false,
      style
    }
  },
  computed: {
    computedDateLanguage() {
      switch (this.$i18n.locale) {
        case 'en':
          return DateEN
        case 'ja':
          return DateJA
        case 'zh_Hans':
          return DateZH
        case 'zh_Hant':
          return DateZH
        case 'ko':
          return DateKO
        default:
          return DateEN
      }
    },
    activeForm() {
      return this.formStore.activeFormName
    },
    activeField() {
      return this.formStore.activeField
    },
    pickupTime() {
      return this.formStore.rentalCarForm.pickupTime
    }
  },
  methods: {
    bottomPanelSend() {
      if (this.datePickerWidgetId) EventBus.$emit('disableDateWidget', this.datePickerWidgetId)
      const replyString = `${this.selectedDate} ${this.selectedTime}`
      if (this.activeForm === 'rentalCarForm') {
        this.$rollbar.info('rentalCarForm bottomPanelSend')
        this.formStore.setFormFieldValue(replyString)
        if (this.activeField === 'pickupTime') {
          this.formStore.resetOtherFormFields(['returnTime'])
        }
      } else {
        Chat.sendMessage(replyString)
      }
      this.closePanel()
    },
    updateSelectedTime(timeString) {
      this.selectedTime = timeString
    },
    closePanel() {
      this.bottomPanelStore.setBottomPanelComponent()
    }
  }
}
</script>
